export default __webpack_public_path__ + "85fc1ccc18f000a0f6f6f4edaffb95e3.png";